module.exports = __webpack_public_path__ + "static/media/cog.0868da60.svg";